import { connect } from 'react-redux'
import Courses from 'modules/Courses/index'
import {
  getCoursesList,
  AddCourses,
  getSkillList,
  DeleteCourses,
  EditCourses,
  ActiveIsCourses,
  DeleteSpecialization,
  AddMultiCourses,
} from 'modules/Courses/actions'
import Selector from 'modules/Courses/selectors'
import { getDegreeData } from 'modules/Students/actions'

import instSelector from 'modules/Students/selectors'
import authSelector from 'modules/Auth/selectors'

const mapStateToProps = state => ({
  degreeList: Selector.getCourseList(state),
  degreeFilterList: instSelector.getStudentDegreeList(state),
  permissions: authSelector.getUserPermissions(state),
  skillListData: Selector.getSkillList(state),
})

const mapDispatchToProps = {
  getCoursesList,
  getSkillList,
  AddCourses,
  AddMultiCourses,
  getDegreeData,
  DeleteCourses,
  EditCourses,
  ActiveIsCourses,
  DeleteSpecialization,
}

export default connect(mapStateToProps, mapDispatchToProps)(Courses)
